import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { authorizedState, loginModalState } from "atoms/atoms";

import { AUTH_BASE_URL } from "../../../config/config";
import Loader from "../../shared/loader/Loader";
import AnalyticsService from "../../../services/analytics";

import "../register/register.scss";

function Login({ onRegisterClick, onModalDismiss }) {
  const [loginModalStateValue, setLoginModalState] = useRecoilState(loginModalState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({});
  const setAuthorized = useSetRecoilState(authorizedState);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    AnalyticsService.sendPageView("/bejelentkezes");

    fetch(`${AUTH_BASE_URL}/login/state`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then(
        (json) => {
          setAuthorized((json.email) ? true : false);
        },
        (error) => setAuthorized(false),
      );

  }, [id, setAuthorized]);

  const validate = () => {
    let isValid = true;

    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(String(formData.email).toLowerCase())) {
      setError(prev => ({ ...prev, email_error: "Helytelen e-mail cím" }));
      isValid = false;
    } else {
      setError(prev => ({ ...prev, email_error: "" }));
    }

    if (!formData.password || formData.password.length === 0) {
      setError(prev => ({ ...prev, password_error: "A jelszó mező nem lehet üres!" }));
      isValid = false;
    } else {
      setError(prev => ({ ...prev, password_error: "" }));
    }

    return isValid;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (validate() === true) {
      setLoading(true);
      const requestBody = JSON.stringify(formData);

      fetch(`${AUTH_BASE_URL}/login`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: requestBody,
      })
        .then((res) => res.json())
        .then(
          (json) => {
            if (json.token) {
              sessionStorage.setItem("token", json.token);
              sessionStorage.setItem("provider", "portal");
              setError(null);
              setLoading(false);
              setLoginSuccess(true);
              setTimeout(() => {
                setAuthorized(true);
                onModalDismiss();

                if (loginModalStateValue.redirectAfterLogin) {
                  navigate(loginModalStateValue.redirectAfterLogin);
                }

                setLoginModalState(prev => ({ ...prev, redirectAfterLogin: null }));
              }, 1500);
            } else {
              setLoading(false);
              setAuthorized(false);
              setLoginSuccess(false);
              setError(prev => ({ ...prev, login_error: "Hibás e-mail cím és/vagy jelszó!" }));
            }
          },
          (error) => {
            setLoading(false);
            setAuthorized(true);
            setError(prev => ({ ...prev, login_error: "Technikai hiba történt, kérjük próbáld meg a bejelentkezést később!" }));
          },
        );
    }
  };

  const handleChange = (event) => {
    const isCheckbox = event.target.type === "checkbox";

    setError(prev => ({ ...prev, login_error: "" }));
    setFormData(prev => ({ ...prev, [event.target.name]: (isCheckbox ? event.target.checked : event.target.value) }));
  };

  const handleLostPasswordClick = () => {
    onModalDismiss();
    navigate("/elfelejtett-jelszo");
  };

  return (
    <section className="main-content">
      <div className="login-container">
        <h2 className="h2">Bejelentkezés</h2>
        <p className="text-center login-lead">
          Ha gondod van a belépéssel, a Honvéd Shop-os felhasználónevedról a regisztrációt visszaigazoló e-mailünkben találsz információt, ha pedig elfelejtetted a jelszavadat, kattints az &quot;eflelejtettem a jelszavam&quot; hivatkozásra.
        </p>
        {/* <div className="social-container">
              <div>
                <FacebookLogin
                  appId="479443535523657"
                  autoLoad={true}
                  fields="name,email,picture"
                  cssClass="btn-custom-facebook"
                  callback={this.responseFacebook}
                />
              </div>
              <div>
                <GoogleLogin
                  clientId="484814130569-fbfd4v7abqsumklpfllgdi4c31u52mtd.apps.googleusercontent.com"
                  buttonText="Login with Google"
                  onSuccess={responseGoogle}
                  onFailure={responseGoogle}
                  cookiePolicy={'single_host_origin'}
                  className={'g-signin2'}
                />
              </div>
            </div>
            <div className="separator">
              <p>vagy</p>
              <span></span>
            </div> */}
        {loginSuccess && (
          <div className="login-success-message">
            Sikeresen bejelentkeztél
          </div>
        )}
        {error?.login_error && (
          <div className="login-error-message">
            {error.login_error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="user-email">Email cím</label>
            <input
              type="text"
              className="form-control"
              name="email"
              value={formData.email || ""}
              onChange={handleChange}
            />
            <div className="validation_error">{error?.email_error}</div>
          </div>
          <div className="form-group">
            <label htmlFor="user-password">Jelszó</label>
            <input
              type="password"
              className="form-control"
              name="password"
              value={formData.password || ""}
              onChange={handleChange}
            />
            <div className="validation_error">{error?.password_error}</div>
          </div>
          <div className="text-center submit-container">
            <button type="submit" className="btn btn-primary" disabled={(loading === true)}>Bejelentkezés</button>
            {loading && (
              <Loader />
            )}
          </div>
        </form>
        <div className="text-center lost-password-container">
          <a className="lost-password" onClick={handleLostPasswordClick}>Elfelejtettem a jelszavam</a>
        </div>
        <div className="text-center register-link-container">
          <p>
            Nincs még tagságod?&nbsp;
            <span className="link" onClick={onRegisterClick}><strong><u>Regisztrálj most!</u></strong></span>
          </p>
        </div>
      </div>
    </section>
  );
}

export default Login;
